import { render, staticRenderFns } from "./CompanyTransferCreate.vue?vue&type=template&id=2c45906e&scoped=true&"
import script from "./CompanyTransferCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyTransferCreate.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTransferCreate.vue?vue&type=style&index=0&id=2c45906e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45906e",
  null
  
)

export default component.exports